<template>
    <ErrorMessage
        class="my-16"
        :status-code="statusCode"
        :error-message="errMsg"
    ></ErrorMessage>
</template>

<script lang="ts" setup>
    import type { NuxtError } from '#app';
    import { useCustomError } from '~/composables';
    import ErrorMessage from '~/components/error/ErrorMessage/ErrorMessage.vue';

    const props = defineProps<{
        error?: Nilish<NuxtError | Error>;
    }>();

    const useCustomErrorObj = useCustomError();

    const statusCode = computed<number>(() => (props.error && 'statusCode' in props.error) ? props.error.statusCode : 500);
    const errMsg = useCustomErrorObj.getErrorMsgFromCode(statusCode);
</script>

<style lang="scss"></style>
